import { Button, GenericError, ModalComponent, ModalHeader, ToastMessage } from "components";
import React from "react";
import { ButtonRow, SeparateLine } from "styles/elements/main";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import Spinner from "components/Spinner";
import useVerificationSubmit from "hooks/useVerificationSubmit";
import useVerificationObjection from "hooks/useVerificationObjection";
import { OthersSection, PaymentMethods, PersonalInfo, WorkingInfo } from "./components";
import useFetchDriver from "./config/useFetchDriver";

const DriverVerifyModal = ({ open, onClose, driverId, driverStaus }) => {
    const { fetchedDdata, fetchedAttachments, setAttachments } = useFetchDriver(
        driverId,
        "supplier,paymentMethod,attachments"
    );
    const { objections, handleObjections } = useVerificationObjection();
    const { onSuccess, isLoading, handleReviewSubmition, backEndErorr } = useVerificationSubmit(
        objections,
        onClose,
        driverId,
        "drivers"
    );
    return (
        <>
            <ModalComponent
                header={
                    <ModalHeader
                        entityName="Driver Profile Details"
                        entityId={driverId}
                        entityStatus={driverStaus}
                    />
                }
                borderedHeader
                size="large"
                open={open}
                onClose={onClose}
            >
                <PersonalInfo
                    driverData={fetchedDdata}
                    uploadedAttachments={fetchedAttachments}
                    setAttachments={setAttachments}
                    // eslint-disable-next-line react/jsx-no-bind
                    handleObjections={handleObjections}
                    isQARole
                />

                <SeparateLine />
                <WorkingInfo
                    driverData={fetchedDdata}
                    uploadedAttachments={fetchedAttachments}
                    // eslint-disable-next-line react/jsx-no-bind
                    handleObjections={handleObjections}
                    setAttachments={setAttachments}
                    isQARole
                />
                <SeparateLine />
                <PaymentMethods
                    driverData={fetchedDdata}
                    // eslint-disable-next-line react/jsx-no-bind
                    handleObjections={handleObjections}
                    isQARole
                />
                <SeparateLine />
                <OthersSection
                    driverData={fetchedDdata?.notes}
                    isQARole
                />
                {backEndErorr && <GenericError errorMassege={backEndErorr} />}
                <ButtonRow>
                    <Button
                        onChange={onClose}
                        name="Cancel"
                        btnStyle="secondBtn"
                        type="button"
                    />
                    <Button
                        btnStyle={isLoading || !(objections.length > 0) ? "disabled" : "primaryBtn"}
                        type="submit"
                        name={isLoading ? <Spinner /> : "Submit"}
                        disabled={!(objections.length > 0)}
                        icon={!isLoading && <AddCircleOutlineOutlinedIcon />}
                        onChange={handleReviewSubmition}
                    />
                </ButtonRow>
            </ModalComponent>
            {onSuccess && (
                <ToastMessage
                    name="driver"
                    type="success"
                    text="verification success"
                    showToast={onSuccess}
                />
            )}
        </>
    );
};

export default DriverVerifyModal;
